import { createAction } from '@reduxjs/toolkit';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { ServerTime } from '../../helpers/serverTime';

export const setParentalControlsManagerVisibility = createAction<boolean>(
  'ui/setParentalControlsManagerVisibility'
);

export const setFavouritesPopupVisibility = createAction<boolean>(
  'ui/setFavouritesPopupVisiblity'
);

export const setServerTime = createAction<ServerTime>('ui/setServerTime');

export const setCurrentlyPlayingAsset = createAction<SvpAssetAdditional>(
  'ui/setCurrentlyPlayingAsset'
);

export const clearCurrentlyPlayingAsset = createAction(
  'ui/clearCurrentlyPlayingAsset'
);

export const setIsHeaderSticky = createAction<boolean>('ui/setIsHeaderSticky');
